import * as v from 'valibot';

import { WEIGHT_UOMS } from '@/views/screens/common/types';
import { SHIPMENT_TYPES } from '@/views/screens/Shipment/types';

const yesNoNullableSchema = v.optional(v.union([v.literal('Y'), v.literal('N'), v.literal(''), v.null()]));

const ISODateTimeStringSchema = v.pipe(
  v.string(),
  v.check((value) => {
    const d = new Date(value);
    return !Number.isNaN(d.getTime());
  }, 'Invalid ISO datetime'),
);

/* Early Shipment Restriction Schema  */
export const earlyShipmentRestrictionDetailsSchema = v.object({
  cargoDesc: v.optional(v.string()),
  cargoType: v.string(),
  createdBy: v.optional(v.string()),
  createdOn: v.optional(ISODateTimeStringSchema),
  customerKey: v.number(),
  id: v.optional(v.number()),
  maximumDays: v.number(),
  maximumDaysError: v.string(),
  modifiedBy: v.optional(v.nullable(v.string())),
  modifiedOn: v.optional(v.nullable(ISODateTimeStringSchema)),
});

/* TMS Settings API Schema  */
export const tmsSettingsApiSchema = v.object({
  adminEmail: v.nullable(v.string()),
  allowDraftShipments: yesNoNullableSchema,
  allowIncoCode: v.boolean(),
  autoRate: yesNoNullableSchema,
  autoTender: yesNoNullableSchema,
  autoTenderAmount: v.nullable(v.number()),
  autoTenderCargoType: v.nullable(v.string()),
  bidExpiryNoOfDays: v.nullable(v.number()),
  brokerageCustomer: yesNoNullableSchema,
  createdBy: v.number(),
  createdOn: ISODateTimeStringSchema,
  customerKey: v.number(),
  defaultBranchKey: v.nullable(v.number()),
  defaultBusinessJustification: v.nullable(v.string()),
  defaultCargoType: v.nullable(v.string()),
  defaultClass: v.nullable(v.string()),
  defaultEquipmentType: v.nullable(v.number()),
  defaultFobCode: v.nullable(v.string()),
  defaultFreightClass: v.nullable(v.string()),
  defaultHazmat: yesNoNullableSchema,
  defaultHeight: v.nullable(v.string()),
  defaultIncoTerm: v.nullable(v.string()),
  defaultLen: v.nullable(v.string()),
  defaultPackageUom: v.nullable(v.string()),
  defaultPaymentTerms: v.nullable(v.string()),
  defaultProdDesc: v.nullable(v.string()),
  defaultProductCode: v.nullable(v.string()),
  defaultRatingPreferencevalue: v.nullable(v.string()),
  defaultShipmentTerms: v.nullable(v.string()),
  defaultShipmentType: v.nullable(v.picklist(Object.keys(SHIPMENT_TYPES))),
  defaultSpotBidEndStatus: v.nullable(v.string()),
  defaultUom: v.nullable(v.picklist(Object.keys(WEIGHT_UOMS))),
  defaultWidth: v.nullable(v.string()),
  disableExpiredBids: yesNoNullableSchema,
  displayPO_SOOnShipmentLevel: yesNoNullableSchema,
  earlyShipmentRestrictionDetails: v.nullable(v.array(earlyShipmentRestrictionDetailsSchema)),
  emailFrom: v.nullable(v.string()),
  enableMasterOrders: yesNoNullableSchema,
  isAllowEarlyShipmentRestriction: yesNoNullableSchema,
  isBillToVisible: yesNoNullableSchema,
  isCargo: yesNoNullableSchema,
  isCatchDate: yesNoNullableSchema,
  isCategoryToValidate: yesNoNullableSchema,
  isCategoryVisible: yesNoNullableSchema,
  isDefaultRatingPreference: yesNoNullableSchema,
  isDefaultSelected: yesNoNullableSchema,
  isDisableInsurance: yesNoNullableSchema,
  isEquipment: yesNoNullableSchema,
  isHideShipmentNumber: yesNoNullableSchema,
  isPoItemLocation: yesNoNullableSchema,
  isRequiredApprovalNumber: yesNoNullableSchema,
  isReverseAuction: yesNoNullableSchema,
  isShowRatingDetails: yesNoNullableSchema,
  isVendorVisible: yesNoNullableSchema,
  isvisiablePaidBy: yesNoNullableSchema,
  isWeightCalculation: yesNoNullableSchema,
  itemsDistribution: yesNoNullableSchema,
  maxBidHours: v.nullable(v.number()),
  maximumDays: v.nullable(v.number()),
  maximumDaysErrorMsg: v.nullable(v.string()),
  minimumDays: v.nullable(v.number()),
  minimumDaysErrorMsg: v.nullable(v.string()),
  modifiedBy: v.nullable(v.nullable(v.number())),
  modifiedOn: v.nullable(ISODateTimeStringSchema),
  nextID: v.nullable(v.number()),
  numberOfRoutingCarrierReturned: v.nullable(v.number()),
  parcelReDirectLink: v.nullable(v.string()),
  poValidationFlag: yesNoNullableSchema,
  povDestinationMethod: v.nullable(v.string()),
  pricingType: v.nullable(v.string()),
  qtyTolerancePercentage: v.nullable(v.number()),
  recalculateFreightClass: v.union([v.number(), yesNoNullableSchema]),
  routingGuideMatch: yesNoNullableSchema,
  routingMethod: v.nullable(v.string()),
  shipmentApprovalCount: v.nullable(v.number()),
  shipmentApprovalRequired: yesNoNullableSchema,
  shipmentEmailAttachment: yesNoNullableSchema,
  shipmentIdAlphaPrefix: v.nullable(v.string()),
  shipmentIdStartingInteger: v.nullable(v.number()),
  shipmentSupportMail: v.nullable(v.string()),
  shipmentTermsAllowed: v.nullable(v.string()),
  showCurrentBid: yesNoNullableSchema,
  statusInTMS: yesNoNullableSchema,
});

export type EarlyShipmentRestrictionDetails = v.InferOutput<typeof earlyShipmentRestrictionDetailsSchema>;
export type TMSSettingsApi = Nullable<v.InferOutput<typeof tmsSettingsApiSchema>>;
